import { SupportedImage } from "./supportedImage";
import React from "react";

export const Supported = (props) => {
  return (
    <div id="supported" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Supported By</h2>
        </div>
        <div className="row">
          <div className="supported-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <SupportedImage
                      title={d.title}
                      url={d.url}
                      image={d.image}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
